module.exports = __webpack_public_path__ + "img/icons8-taxi-license.bdd398bb.svg";